export const sliderData = [
  {
    id: 1,
    tabs: ['desktop', 'mobile', 'voice'],
    videos: [
      {
        id: 1,
        activeTab: 'desktop',
        url: 'https://cityfalcon.wistia.com/medias/ajt73zy7sg',
      },
      {
        id: 2,
        activeTab: 'mobile',
        url: 'https://cityfalcon.wistia.com/medias/mftbajn65v',
      },
      {
        id: 3,
        activeTab: 'voice',
        url: 'https://cityfalcon.wistia.com/medias/49ndnczbz8',
      },
    ],
  },
  {
    id: 2,
    tabs: ['desktop', 'mobile'],
    videos: [
      {
        id: 1,
        activeTab: 'desktop',
        url: 'https://cityfalcon.wistia.com/medias/k55d2nkan7',
      },
      {
        id: 2,
        activeTab: 'mobile',
        url: 'https://cityfalcon.wistia.com/medias/nvrijpors2',
      },
    ],
  },
  {
    id: 3,
    tabs: ['desktop'],
    videos: [
      {
        id: 1,
        activeTab: 'desktop',
        url: 'https://cityfalcon.wistia.com/medias/wijksrco2x',
      },
    ],
  },
  {
    id: 4,
    tabs: ['desktop', 'mobile'],
    videos: [
      {
        id: 1,
        activeTab: 'desktop',
        url: 'https://cityfalcon.wistia.com/medias/nq8g9ra0th',
      },
      {
        id: 2,
        activeTab: 'mobile',
        url: 'https://cityfalcon.wistia.com/medias/el5pzya155 ',
      },
    ],
  },
  {
    id: 5,
    tabs: ['desktop', 'mobile'],
    videos: [
      {
        id: 1,
        activeTab: 'desktop',
        url: 'https://cityfalcon.wistia.com/medias/k5usrkqi3k',
      },
      {
        id: 2,
        activeTab: 'mobile',
        url: 'https://cityfalcon.wistia.com/medias/2eznzz1ra6',
      },
    ],
  },
  {
    id: 6,
    tabs: ['desktop', 'mobile'],
    videos: [
      {
        id: 1,
        activeTab: 'desktop',
        url: 'https://cityfalcon.wistia.com/medias/ss2alfe5pj',
      },
      {
        id: 2,
        activeTab: 'mobile',
        url: 'https://cityfalcon.wistia.com/medias/bg126ct1i0',
      },
    ],
  },
  {
    id: 7,
    tabs: ['desktop', 'mobile'],
    videos: [
      {
        id: 1,
        activeTab: 'desktop',
        url: 'https://cityfalcon.wistia.com/medias/362922bfs9',
      },
      {
        id: 2,
        activeTab: 'mobile',
        url: 'https://cityfalcon.wistia.com/medias/xxio1ni47b',
      },
    ],
  },
  {
    id: 8,
    tabs: ['desktop', 'mobile'],
    videos: [
      {
        id: 1,
        activeTab: 'desktop',
        url: 'https://cityfalcon.wistia.com/medias/be7nogrmi6',
      },
      {
        id: 2,
        activeTab: 'mobile',
        url: 'https://cityfalcon.wistia.com/medias/u1x1niau9u',
      },
    ],
  },
  {
    id: 9,
    tabs: ['desktop', 'mobile'],
    videos: [
      {
        id: 1,
        activeTab: 'desktop',
        url: 'https://cityfalcon.wistia.com/medias/ld0y8ltub3',
      },
      {
        id: 2,
        activeTab: 'mobile',
        url: 'https://cityfalcon.wistia.com/medias/ktxo5yh7gp',
      },
    ],
  },
];
